








































































































































import {Vue, Component} from 'vue-property-decorator';
import AnimatedInput from "@/components/AnimatedInput.vue";
import AnimatedTextarea from '@/components/AnimatedTextarea.vue';
import User from "@/models/User";
import SignupAdapter from "@/adapters/signup";
import Address from "@/models/Address";
import { AxiosError } from 'axios';
import Adapter from "@/adapters/base";
import countries from "@/util/countries";
import {Getter} from "vuex-class";

const signupAdapter = new SignupAdapter();
const baseAdapter = new Adapter();

@Component({
  components: {AnimatedInput, AnimatedTextarea},
})
export default class Pro extends Vue {

  @Getter isLoggedIn!: boolean;

  allowSubmit: boolean = false;
  consent: boolean = false;
  enterme: string = "";
  user: User = User.createEmpty();
  address: Address = Object.assign(new Address(), { country: 'DE' });
  signupStarted: boolean = false;

  enterpriseSelected: boolean = false;
  fullname: string = "";
  email: string = "";
  phone: string = "";
  message: string = "";

  countries = countries;

  submitEnterpriseRequest() {
    if (!this.consent) {
      this.$swal('Zustimmung notwendig', 'Bitte akzeptiere die AGB und Datenschutzbedinungen', 'error');
      return;
    }

    const sanName = this.fullname.trim();
    const sanMail = this.email.trim();
    const sanPhone = this.phone.trim();
    const sanConsent = this.consent ? "ja" : "nein";
    const sanMessage = this.message.trim();

    if (sanName === "" || sanMail === "") {
      this.$swal('Daten fehlen', 'Bitte gib mindestens Name und E-Mail-Adresse an.', 'error');
      return;
    }

    const payload = {
      name: sanName,
      email: sanMail,
      phone: sanPhone,
      message: sanMessage,
      hp: this.enterme,
      consent: sanConsent,
    };

    if (!this.allowSubmit) {
      payload.hp = "asdf"; //If submitted too early, ignore on server
    }

    baseAdapter.request({
      method: 'post',
      url: '/feedback',
      data: payload,
    }).then(() => {
      this.$router.push('/');
      this.$swal('Erfolg', 'Vielen Dank für Deine Anfrage. Wir melden uns schnellstmöglich bei Dir!', 'success');
    }).catch(() => {
      this.$swal('Fehler', 'Ein Fehler trat auf. Versuche es später nochmal oder sende Deine Anfrage direkt an info@uniki.de', 'error');
    });
  }

  startSignup() {
    if (!this.consent) {
      this.$swal('Zustimmung notwendig', 'Bitte akzeptiere die AGB und Datenschutzbedinungen', 'error');
      return;
    }

    const that = this;
    signupAdapter.startSignup(this.user, this.address).then((data: User) => {
      that.signupStarted = true;
      that.$nextTick(() => {
        //@ts-ignore
        const novalnet: any = Novalnet;
        novalnet.setParam("nn_it", "inline");
        novalnet.setParam("txn_secret", data.paymentToken);
        novalnet.render('novalnet_payment_form');
      });
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else if (error.response && error.response.status === 409) {
        if (error.response.data.message === 'user invited') {
          this.$swal('Registrierung abschließen', 'Wir haben Dir einen Link an die eingegebene E-Mail Adresse gesendet. Bitte öffne die E-Mail und klicke auf den Link, um die Registrierung abzuschließen.', 'info');
        } else {
          this.$toast.info("Die E-Mail-Adresse ist bereits registriert. Bitte logge Dich ein.");
          this.$router.push('login');
        }
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    });
  }

  mounted() {
    setTimeout(() => {
      this.allowSubmit = true;
    }, 3333);
  }
}
